<template lang="pug">
.v-footer-collapse.footer-collapse(:class="{open}")
	template(v-if="isTablet")
		.footer-collapse__btn(@click="open = !open")
			.footer-collapse__btn-text {{data.title}}
			v-svg-icon.footer-collapse__btn-icon(icon="select-arrow")
		v-collapse(:open="open")
			.footer-collapse__body
				slot
	template(v-else="")
		slot
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "./mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		data: {
			type: Object,
			default: null
		}
	},

	watch: {
		data(state) {
			if(state.open) {
				this.open = state.open
			}
		}
	},

	mounted() {
		if (this.data) {
			this.open = this.data.open;
		}
	},

	data() {
		return {
			open: false
		}
	}
}

</script>